/* edge-r-faq: FAQ page behaviour (pass 7, H6). Loaded with defer by sections/edge-r-faq.liquid only.
   Search-as-you-type over questions and answers, quick searches, #question deep links, copy-link
   buttons and the topic highlight. Without this file the answers still open (<details>) and the
   search form goes to the store search. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.faqReady) return;
    root.dataset.faqReady = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var form = root.querySelector('[data-faq-form]');
    var input = root.querySelector('[data-faq-input]');
    var clearBtn = root.querySelector('[data-faq-clear]');
    var status = root.querySelector('[data-faq-status]');
    var empty = root.querySelector('[data-faq-empty]');
    var toast = root.querySelector('[data-faq-toast]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-faq-nav]'));
    var one = root.dataset.statusOne || 'answer';
    var many = root.dataset.statusMany || 'answers';
    var total = items.length;

    items.forEach(function (d) {
      var qt = d.querySelector('[data-faq-q]');
      var ans = d.querySelector('[data-faq-a]');
      d._qEl = qt;
      d._q = qt ? qt.textContent : '';
      d._text = (d._q + ' ' + (ans ? ans.textContent : '')).toLowerCase();
    });

    function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function escHtml(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    function filter() {
      if (!input) return;
      var raw = input.value.trim();
      var q = raw.toLowerCase();
      var words = q.split(/\s+/).filter(Boolean);
      var n = 0;
      var re = words.length ? new RegExp('(' + words.map(escRe).join('|') + ')', 'gi') : null;
      if (form) form.classList.toggle('is-filled', q.length > 0);

      items.forEach(function (d) {
        var hit = words.every(function (w) { return d._text.indexOf(w) > -1; });
        d.hidden = !hit;
        if (hit) n++;
        if (d._qEl) {
          if (re) d._qEl.innerHTML = escHtml(d._q).replace(re, '<mark>$1</mark>');
          else d._qEl.textContent = d._q;
        }
        if (q.length >= 3 && hit && n <= 3 && !d.open) d.open = true;
      });

      groups.forEach(function (g) {
        var vis = g.querySelectorAll('[data-faq-item]:not([hidden])').length;
        g.hidden = vis === 0;
        if (!g.id) return;
        navLinks.forEach(function (a) {
          if (a.getAttribute('data-faq-nav') !== g.id) return;
          a.classList.toggle('is-none', vis === 0);
          var c = a.querySelector('.edge-r-faq__count');
          if (c) c.textContent = vis;
        });
      });

      if (empty) empty.hidden = n !== 0;
      if (status) {
        if (!q) status.textContent = total + ' ' + (total === 1 ? one : many);
        else if (n === 0) status.textContent = 'No answers match "' + raw + '"';
        else status.textContent = n + (n === 1 ? ' answer matches' : ' answers match') + ' "' + raw + '"';
      }
    }

    function firstVisible() { return root.querySelector('[data-faq-item]:not([hidden])'); }
    function scrollToEl(el, smooth) {
      var top = el.getBoundingClientRect().top + window.scrollY - 96;
      window.scrollTo({ top: top, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    }

    if (input) {
      input.addEventListener('input', filter);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { input.value = ''; filter(); }
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var first = firstVisible();
        if (first) scrollToEl(first, true);
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () { input.value = ''; filter(); input.focus(); });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-faq-quick]'), function (b) {
      b.addEventListener('click', function () {
        if (!input) return;
        input.value = b.getAttribute('data-faq-quick');
        filter();
        var first = firstVisible();
        if (first) scrollToEl(first, true);
      });
    });

    // deep links: #question opens that answer, #topic jumps to the topic
    function openHash(smooth) {
      var id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (err) { return; }
      if (!id) return;
      var el = document.getElementById(id);
      if (!el || !root.contains(el)) return;
      if (input && input.value) { input.value = ''; filter(); }
      if (el.hasAttribute('data-faq-item')) {
        el.open = true;
        el.classList.remove('is-flash');
        void el.offsetWidth;
        el.classList.add('is-flash');
      }
      scrollToEl(el, smooth);
    }
    window.addEventListener('hashchange', function () { openHash(true); });
    if (location.hash) setTimeout(function () { openHash(false); }, 60);

    // copy-link buttons
    var toastTimer;
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-shown');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-shown'); }, 2200);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-faq-copy]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var hash = a.getAttribute('href');
        var url = location.href.split('#')[0] + hash;
        try { history.replaceState(null, '', hash); } catch (err) { /* ignore */ }
        var copied = toast ? toast.dataset.copied : '';
        var fallback = toast ? toast.dataset.fallback : '';
        try {
          navigator.clipboard.writeText(url).then(function () { showToast(copied); }, function () { showToast(fallback); });
        } catch (err) {
          showToast(fallback);
        }
      });
    });

    // topic list: highlight the topic in view
    if ('IntersectionObserver' in window && navLinks.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          navLinks.forEach(function (a) { a.classList.toggle('is-current', a.getAttribute('data-faq-nav') === en.target.id); });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      groups.forEach(function (g) { if (g.id) io.observe(g); });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-edge-r-faq]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // theme editor: re-run when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-edge-r-faq]'), init);
  });
})();
